import React from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import { useTranslation } from "react-i18next";

// LCA Results icon
const LCAResultsIcon = () => (
  <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M38 10L20 25V35C20 45 25 55 38 60C51 55 56 45 56 35V25L38 10Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 38L38 43L56 38" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 43V60" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M28 20L38 25L48 20" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const LCAResultsHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <CategoryComponent
      show={show}
      className={`lca-results-48-category ${className || ""}`}
      leftBoxProps={{
        icon: <LCAResultsIcon />,
        title: t("LCA_RESULTS") || "LCA Results",
        description:
          t("LCA_RESULTS_DESC") ||
          "Environmental impact results per lifecycle module according to EN 15804+A2. Results are calculated based on selected phases and show impact indicators per functional unit.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [],
        impactTotals: null,
        lastUpdated: null,
        customTextColor: "white",
        ...rightBoxProps,
      }}
    />
  );
};

export default LCAResultsHeader;

